import { render, staticRenderFns } from "./FamilyAnamnesis.vue?vue&type=template&id=61a95584&"
import script from "./FamilyAnamnesis.vue?vue&type=script&lang=js&"
export * from "./FamilyAnamnesis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../Projects/register/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports